<template>
  <div class="section-page container">
    <main class="card section-card">
      <h1 class="hero-title">
        <span class="highlight">Науки о Жизни</span>
        <span class="title-divider"></span>
      </h1>
      <p class="hero-desc">
        Раздел находится в разработке. Пример полного набора данных по образцу из этой категории можно
        <span class="highlight">скачать по ссылке</span> ниже.
      </p>

      <section class="sample-example" aria-labelledby="sample-title">
        <h2 id="sample-title" class="sample-title">Образец-пример: BFX_457 (Лягушка)</h2>

        <div class="sample-grid">
          <div class="gallery">

            <div class="main-frame" role="group">
              <img
                :src="currentImage"
                :alt="title + ' — изображение ' + (currentIndex+1)"
                class="main-img"
                @click="openModal(currentIndex)"
              />
              <div v-if="images.length > 1" class="img-counter">{{ currentIndex + 1 }} / {{ images.length }}</div>
            </div>

            <div class="thumbs" aria-hidden="false">
              <button
                v-for="(img, i) in images"
                :key="i"
                :class="['thumb-btn', { 'active': currentIndex === i }]"
                @click="setIndex(i)"
                :aria-label="`Показать изображение ${i+1}`"
              >
                <img :src="img" :alt="'thumb ' + (i+1)" />
              </button>
            </div>
          </div>

          <aside class="params">
            <h3 class="params-title">Параметры съёмки КТ</h3>
            <dl class="params-list">
              <div class="p-row"><dt>Томограф</dt><dd>SkyScan 1172</dd></div>
              <div class="p-row"><dt>Фильтр</dt><dd>Без фильтра</dd></div>
              <div class="p-row"><dt>Напряжение, кВ</dt><dd>40</dd></div>
              <div class="p-row"><dt>Ток, мА</dt><dd>0.25</dd></div>
              <div class="p-row"><dt>Разрешение, мкм</dt><dd>5.99</dd></div>
            </dl>
          </aside>
        </div>
      </section>
      <div class="actions">
        <a :href="downloadUrl" target="_blank" rel="noopener" class="btn btn-primary">Скачать полный набор данных</a>
      </div>
    </main>

    <teleport to="body">
      <transition name="fade">
        <div v-if="isModalOpen" class="iv-modal" @click.self="closeModal" role="dialog" aria-modal="true">
          <button class="iv-modal-close" @click="closeModal" aria-label="Close image">✕</button>

          <template v-if="!hasImages || modalImageError">
            <div class="modal-noimage">
              <div class="noimage-box">
                <div class="noimage-ico">🖼️</div>
                <div class="noimage-text">Изображение отсутствует</div>
                <div class="noimage-sub">Нет доступных превью для этого образца.</div>
              </div>
            </div>
          </template>

          <template v-else>
            <button v-if="images.length > 1" class="iv-nav left" @click.stop="prevImageModal" aria-label="Previous image">‹</button>

            <div class="iv-modal-inner" @click.stop>
              <img :src="currentModalImage" class="iv-modal-img" :alt="title + ' full'" @error="onModalImageError" />
              <div v-if="images.length > 1" class="iv-modal-indicator">{{ modalIndex + 1 }} / {{ images.length }}</div>
            </div>

            <button v-if="images.length > 1" class="iv-nav right" @click.stop="nextImageModal" aria-label="Next image">›</button>
          </template>
        </div>
      </transition>
    </teleport>
  </div>
</template>

<script>
import image1 from '@/assets/BFX_457_1.jpg'
import image2 from '@/assets/BFX_457_3.jpg'
import image3 from '@/assets/BFX_457_7.jpg'

export default {
  name: 'LifeView',
  data() {
    return {
      downloadUrl: 'https://disk.360.yandex.ru/d/HTG7r5kpfFM2xA',
      images: [
        image1,
        image2,
        image3
      ],
      currentIndex: 0,
      title: 'BFX_457',

      // modal state
      isModalOpen: false,
      modalIndex: 0,
      modalImageError: false
    }
  },
  computed: {
    currentImage() { return this.images[this.currentIndex] || '/img/placeholder-320.png' },
    hasImages() { return Array.isArray(this.images) && this.images.length > 0 && !this.modalImageError },
    currentModalImage() { return this.images[this.modalIndex] || this.images[0] || '' }
  },
  methods: {
    nextImage() {
      if (!this.images || this.images.length <= 1) return
      this.currentIndex = (this.currentIndex + 1) % this.images.length
    },
    prevImage() {
      if (!this.images || this.images.length <= 1) return
      this.currentIndex = (this.currentIndex - 1 + this.images.length) % this.images.length
    },
    setIndex(i) {
      if (i >= 0 && i < this.images.length) this.currentIndex = i
    },

    // modal controls
    openModal(startIndex = 0) {
      if (!this.images || this.images.length === 0) return
      this.modalIndex = Math.min(Math.max(0, startIndex), this.images.length - 1)
      this.isModalOpen = true
      this.modalImageError = false
      document.body.style.overflow = 'hidden'
      document.body.classList.add('modal-open')
      window.addEventListener('keydown', this.onKeydown)
    },

    closeModal() {
      this.isModalOpen = false
      this.modalImageError = false
      document.body.style.overflow = ''
      document.body.classList.remove('modal-open')
      window.removeEventListener('keydown', this.onKeydown)
    },
    nextImageModal() {
      if (!this.images || this.images.length <= 1) return
      this.modalIndex = (this.modalIndex + 1) % this.images.length
    },
    prevImageModal() {
      if (!this.images || this.images.length <= 1) return
      this.modalIndex = (this.modalIndex - 1 + this.images.length) % this.images.length
    },
    onKeydown(e) {
      if (!this.isModalOpen) return
      if (e.key === 'Escape') this.closeModal()
      else if (e.key === 'ArrowRight') this.nextImageModal()
      else if (e.key === 'ArrowLeft') this.prevImageModal()
    },
    onModalImageError() { this.modalImageError = true }
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this.onKeydown)
    document.body.style.overflow = ''
    document.body.classList.remove('modal-open')
  }
}
</script>

<style scoped>
.container {
  max-width: 900px;
  margin: 32px auto;
  padding: 16px;
}

.section-card {
  padding: 32px;
  border-radius: 16px;
  background-color: var(--card-bg);
  border: 1px solid var(--border-color);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
}

.hero-title {
  font-size: 28px;
  margin: 0 0 16px;
  color: var(--text-primary);
  font-weight: 700;
  text-align: left;
}
.hero-title .highlight {
  color: var(--accent);
}

.title-divider {
  display: block;
  width: 100px;
  height: 3px;
  margin-top: 12px;
  background: linear-gradient(90deg, var(--accent) 0%, transparent 100%);
  border-radius: 2px;
}

.hero-desc {
  font-size: 18px;
  line-height: 1.7;
  color: var(--text-muted);
  max-width: 900px;
  text-align: left;
  margin-bottom: 24px;
}

.hero-desc .highlight {
  color: var(--accent);
  font-weight: 600;
}

.sample-example {
  margin: 32px 0;
  padding-top: 32px;
  border-top: 1px solid var(--border-color);
}

.sample-title {
  font-size: 22px;
  color: var(--text-primary);
  margin: 0 0 24px 0;
  font-weight: 600;
}

.sample-grid {
  display: grid;
  grid-template-columns: 1fr 320px;
  gap: 24px;
  align-items: start;
}

.gallery {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.main-frame {
  width: 100%;
  border-radius: 12px;
  overflow: hidden;
  position: relative;
  background: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 420px;
  min-height: 320px;
  border: 1px solid var(--border-color);
}

.main-img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  cursor: zoom-in;
  transition: transform 0.2s ease-in-out;
}
.main-img:hover {
  transform: scale(1.03);
}

.img-counter {
  position: absolute;
  top: 12px;
  right: 12px;
  background: rgba(11, 17, 30, 0.7);
  backdrop-filter: blur(5px);
  color: var(--text-primary);
  padding: 6px 12px;
  border-radius: 20px;
  font-weight: 600;
  font-size: 13px;
  border: 1px solid var(--border-color);
}

.thumbs {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.thumb-btn {
  border: 2px solid transparent;
  padding: 0;
  background: transparent;
  border-radius: 10px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.2s ease;
  line-height: 0;
}

.thumb-btn img {
  display: block;
  width: 72px;
  height: 72px;
  object-fit: cover;
  border-radius: 8px;
  opacity: 0.6;
  transition: opacity 0.2s ease;
}

.thumb-btn:hover img {
  opacity: 1;
}

.thumb-btn.active {
  border-color: var(--accent);
  box-shadow: 0 0 15px var(--accent-glow);
}

.thumb-btn.active img {
  opacity: 1;
}

.params {
  background: var(--dark-accent-bg);
  border-radius: 12px;
  padding: 20px;
  border: 1px solid var(--border-color);
}

.params-title {
  margin: 0 0 16px;
  font-size: 18px;
  font-weight: 600;
  color: var(--text-primary);
  padding-bottom: 12px;
  border-bottom: 1px solid var(--border-color);
}

.params-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: 0;
  padding: 0;
  font-size: 15px;
}

.p-row {
  display: flex;
  justify-content: space-between;
  gap: 12px;
}

.p-row dt {
  color: var(--text-muted);
  font-weight: 400;
}

.p-row dd {
  margin: 0;
  color: var(--text-primary);
  font-weight: 500;
  text-align: right;
}

.actions {
  display: flex;
  justify-content: left;
  margin-top: 32px;
}

.btn {
  padding: 12px 24px;
  border-radius: 8px;
  text-decoration: none;
  font-weight: 600;
  font-size: 16px;
  transition: all 0.2s ease-in-out;
  border: none;
}

.btn-primary {
  background: var(--accent);
  color: var(--bg-color);
  box-shadow: 0 0 20px var(--accent-glow);
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 25px rgba(117, 228, 245, 0.4);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity .2s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.iv-modal {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2147483000;
  background: rgba(11, 17, 30, 0.384);
  backdrop-filter: blur(8px);
  padding: 60px;
  box-sizing: border-box;
}

.iv-modal-inner {
  position: relative;
  max-width: 100%;
  max-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  width:100%;
  height:100%;
}

.iv-modal-img {
  max-width: 100%;
  max-height: 100%;
  border-radius: 12px;
  object-fit: contain;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.6);
}

.iv-nav {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(30, 41, 59, 0.8);
  border: 1px solid var(--border-color);
  color: var(--text-primary);
  width: 48px;
  height: 48px;
  border-radius: 50%;
  font-size: 24px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
  transition: all 0.2s ease;
}
.iv-nav:hover {
  background-color: var(--accent);
  color: var(--bg-color);
}
.iv-nav.left { left: 16px; }
.iv-nav.right { right: 16px; }

.iv-modal-close {
  position: fixed;
  top: 18px;
  right: 18px;
  z-index: 20;
  width: 44px;
  height: 44px;
  background: rgba(30, 41, 59, 0.8);
  border: 1px solid var(--border-color);
  color: var(--text-primary);
  border-radius: 50%;
  cursor: pointer;
  font-size: 20px;
  transition: all 0.2s ease;
}
.iv-modal-close:hover {
  background-color: var(--accent);
  color: var(--bg-color);
  transform: rotate(90deg);
}

.iv-modal-indicator {
  position: absolute;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(11, 17, 30, 0.7);
  backdrop-filter: blur(5px);
  color: var(--text-primary);
  padding: 8px 16px;
  border-radius: 20px;
  font-weight: 600;
  font-size: 14px;
  border: 1px solid var(--border-color);
}

.noimage-box {
  text-align: center;
  color: var(--text-primary);
  padding: 32px;
  border-radius: 12px;
  background: var(--card-bg);
  border: 1px solid var(--border-color);
}
.noimage-ico { font-size: 48px; }
.noimage-text { font-size: 20px; font-weight: 700; }
.noimage-sub { color: var(--text-muted); }

@media (max-width: 920px) {
  .sample-grid {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 576px) {
  .container {
    margin: 16px auto;
    padding: 8px;
  }
  .section-card {
    padding: 24px;
  }
  .hero-title {
    font-size: 24px;
    text-align: center;
  }
  .title-divider {
    margin-left: auto;
    margin-right: auto;
  }
  .hero-desc {
    text-align: center;
    font-size: 16px;
  }
  .sample-title {
    text-align: center;
  }
  .main-frame {
    height: 320px;
  }
  .iv-modal-inner {
    max-width: 100vw;
    max-height: 100vh;
  }
  .iv-nav {
    display: none;
  }

  .iv-modal {
    padding: 20px;
  }
  .iv-modal-close {
    top: 10px;
    right: 10px;
  }
  .iv-modal-indicator {
    bottom: 10px;
  }
}
</style>